// extracted by mini-css-extract-plugin
export default {"backgroundColor":"#f8f9fa","primaryColor":"#f87a85","grayColor":"gray","gray800":"var(--bs-gray-800)","fullscreen":"LoadingOverlay_fullscreen__oEUrE"};